// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3705":"a21cc537","5897":"3b8d917e"}[chunkId] + ".chunk.css";
};